import { render, staticRenderFns } from "./MyScheduleToday.vue?vue&type=template&id=5951c684&"
import script from "./MyScheduleToday.vue?vue&type=script&lang=js&"
export * from "./MyScheduleToday.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports